// @flow
import { Metadata } from '../../services/metadata'

export const UPDATE_DASHBOARD_GRID = 'grid:updateDashboard'
export type UPDATE_DASHBOARD_GRID_TYPE = {
  type: 'grid:updateDashboard',
  payload: { layout: Object }
}

export const updateDashboard = (layout: Object): UPDATE_DASHBOARD_GRID_TYPE => {

  // update dashboard metadata
  const { updateUserMetadata } = new Metadata()
  const metadata = {
    grid: {
      dashboard: {
        lg: layout,
        md: layout,
        sm: layout,
        xs: layout
      }
    }
  }
  updateUserMetadata(metadata)

  return {
    type: UPDATE_DASHBOARD_GRID,
    payload: { layout }
  }
}

// dashboard status
export const UPDATE_DASHBOARD_STATUS = 'grid:updateDashboardStatus'
export type UPDATE_DASHBOARD_STATUS_TYPE = {
  type: 'grid:updateDashboardStatus',
  payload: {
    isFetching: boolean,
    error: null | string
  }
}

export const updateDashboardStatus = (isFetching: boolean, error: null | string): UPDATE_DASHBOARD_STATUS_TYPE => ({
  type: UPDATE_DASHBOARD_STATUS,
  payload: {
    isFetching,
    error
  }
})



// WEBPACK FOOTER //
// ./src/actions/grid/index.js